// extracted by mini-css-extract-plugin
module.exports = {"tipBox":"ModalIf_style_tipBox__H9siN","tip2":"ModalIf_style_tip2__yYk55","cont":"ModalIf_style_cont__17z48","btnBox":"ModalIf_style_btnBox__1geR4"};